import { Money } from "@redotech/money";
import { getHtml, getReturnType } from "@redotech/redo-model/checkbox";
import { Coverage, PaymentModel } from "@redotech/redo-model/coverage";
import { ToggleFields } from "@redotech/redo-model/team";
import { CURRENCY_FORMAT } from "@redotech/redo-web/currency";
import { TwoLineToggleLabel } from "./toggle";

import { DEFAULT_IMAGE_URL } from "@redotech/redo-model/default-values";
import LogoIcon from "@redotech/redo-web/icon-old/logo-icon.svg";
import htmlReactParser from "html-react-parser";
import { memo } from "react";

import * as cardCss from "./cart-card.module.css";

export const CardIamge = memo(({ img_url }: { img_url: string }) => {
  return (
    <img
      className={cardCss.imageContainer}
      data-target="card-image"
      src={img_url}
    />
  );
});

export const CartCard = ({
  branding,
  color,
  coverage,
  html,
  fontSize,
  toggleFields,
  value,
  onChange,
  paymentModel,
  price,
  customCss,
  image_url,
}: {
  branding: boolean;
  color: string;
  coverage: Coverage;
  html?: string | null;
  fontSize?: number;
  toggleFields: ToggleFields;
  value: boolean;
  onChange(value: boolean): void;
  paymentModel: PaymentModel;
  price: Money | undefined;
  customCss?: string;
  image_url: string;
}) => {
  const buttonText = value ? "REMOVE" : "ADD";
  if (image_url === DEFAULT_IMAGE_URL) {
    image_url = "";
  }

  return (
    <>
      {customCss ? <style>{customCss}</style> : null}

      <div className={cardCss.cardContainer} data-target="card-container">
        {image_url && (
          <img
            className={cardCss.imageContainer}
            data-target="card-image"
            src={image_url}
          />
        )}
        {!image_url && (
          <LogoIcon className={cardCss.redoLogoContainer} data-target="logo" />
        )}

        <div
          className={cardCss.textAndButtonContainer}
          data-target="text-and-buttons-container"
        >
          <TwoLineToggleLabel
            color={color}
            coverage={coverage}
            fontSize={fontSize ?? 14}
            price={undefined}
            toggleSubtitleText={
              value
                ? toggleFields.positiveSubtext
                : toggleFields.negativeSubtext
            }
            toggleTitleText={toggleFields.titleText}
          >
            {html ? (
              htmlReactParser(getHtml(html, getReturnType(coverage)))
            ) : (
              <strong>Free Unlimited Return</strong>
            )}
          </TwoLineToggleLabel>
          <div className={cardCss.actionItems} data-target="action-items">
            <span data-target="price">
              {price && CURRENCY_FORMAT(price.currency).format(price.amount)}
            </span>
            <button
              className={cardCss.button}
              data-target="card-button"
              onClick={() => {
                onChange(!value);
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
